import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  orderEligibilitiesMockEligibleToRefundWithUnOneWay,
  orderWithOneStopScheduleChange,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries';

export const scheduleChangeOnewayOneStopMock: MockMap = {
  retrieveOrder: [createMockData(orderWithOneStopScheduleChange, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundWithUnOneWay, [], [orderNotEligibleForRefundWarning])]
};
